module.exports = __webpack_public_path__ + "assets/img/sig-logo-small.f1550e6e.webp";